import { officialEmotes } from '../official-emotes';
import { isValidExactUrl } from 'wix-rich-content-common';
// TODO: it appears these are not actually used?
export var OfficialHtml = function (children, data) {
    var emoteCode = data.emote.trim();
    if (!officialEmotes[emoteCode]) {
        return '';
    }
    var emote = officialEmotes[emoteCode];
    return "<img src=\"https://e.deviantart.net/emoticons" + emote.src + "\"\n  alt=\"" + emote.name + "\" width=\"" + emote.width + "\" height=\"" + emote.height + "\" />";
};
export var CommunityHtml = function (children, data) {
    if (!data || !data.src) {
        return '';
    }
    if (data.url && isValidExactUrl(data.url)) {
        return "<a href=\"" + data.url + "\"><img src=\"" + data.src + "\" alt=\"" + data.title + "\" width=\"" + data.width + "\" height=\"" + data.height + "\" /></a>";
    }
    return "<img src=\"" + data.src + "\" alt=\"" + data.title + "\" width=\"" + data.width + "\" height=\"" + data.height + "\" />";
};
//# sourceMappingURL=HtmlViewer.js.map